module.exports = __webpack_public_path__ + "img/xiannv.192ba14a.gif";